/* ef-cfg-save.js — Save-your-design v1 + Expert-measure CTA (2026-08-10, GO Daniela)
   Moduł ADDYTYWNY do ef-configurator-v2.js: czyta window._efCfgState, niczego w silniku
   nie nadpisuje. Trzy zadania:
   1) SAVE: serializacja konfiguracji do linku (?efd=), localStorage-autosave,
      baner "Welcome back", modal Copy/Share/Email (Klaviyo event "EF Saved Design").
   2) RESTORE: z ?efd= albo z banera — wymiary przez input events, opcje przez
      programowy click w karty [data-field][data-value] (pełny pipeline silnika:
      dopłaty, cena, podmiany galerii). Pętla ponawiań łapie karty renderowane
      później (np. mesh po wyborze door_type).
   3) EXPERT CTA: tracking kliknięć + delikatny "nudge" karty po 25 s na kroku
      wymiarów albo po 2 nieudanych parse'ach wymiaru.
   dataLayer: ef_cfg_save {method} · ef_cfg_restore {source, applied, pending}
   · ef_cfg_expert_cta {action}. */
(function () {
  'use strict';
  var LS_PREFIX = 'ef-saved-design:';
  var MAX_AGE_DAYS = 30;

  function dl(ev, props) {
    try {
      window.dataLayer = window.dataLayer || [];
      var p = { event: ev };
      for (var k in props) p[k] = props[k];
      window.dataLayer.push(p);
      /* gtag.js (ef-analytics) ignoruje pushe w stylu GTM — forward jawnie,
         ten sam wzorzec co efTrack w silniku (ef-configurator-v2.js). */
      if (typeof window.gtag === 'function') {
        var g = {};
        for (var gk in p) if (Object.prototype.hasOwnProperty.call(p, gk) && gk !== 'event') g[gk] = p[gk];
        window.gtag('event', ev, g);
      }
    } catch (e) {}
  }

  function state() { return window._efCfgState || null; }

  function handle() {
    var m = location.pathname.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : location.pathname;
  }

  /* ── serializacja ─────────────────────────────────────────────── */
  function b64e(obj) {
    var json = JSON.stringify(obj);
    return btoa(unescape(encodeURIComponent(json)))
      .replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }
  function b64d(str) {
    try {
      var s = str.replace(/-/g, '+').replace(/_/g, '/');
      while (s.length % 4) s += '=';
      return JSON.parse(decodeURIComponent(escape(atob(s))));
    } catch (e) { return null; }
  }

  function snapshot() {
    var st = state();
    if (!st) return null;
    var sel = {};
    var any = false;
    for (var k in st.selections) { sel[k] = st.selections[k]; any = true; }
    var notes = document.getElementById('efCfgNotes');
    if (notes && notes.value) { sel.__notes = notes.value; any = true; }
    if (!any) return null;
    return { h: handle(), s: sel, t: Date.now() };
  }

  function buildLink() {
    var snap = snapshot();
    if (!snap) return null;
    return location.origin + location.pathname + '?efd=' + b64e({ h: snap.h, s: snap.s });
  }

  /* Czy konfiguracja jest warta zapisu (realne zaangażowanie, nie same defaulty) */
  function isMeaningful(sel) {
    if (!sel) return false;
    if (sel._width || sel._height) return true;
    var n = 0;
    for (var k in sel) { if (k.charAt(0) !== '_' && k !== '__notes') n++; }
    return n >= 2;
  }

  /* ── restore ──────────────────────────────────────────────────── */
  var DIM_INPUTS = { _width: 'efCfgWidth', _height: 'efCfgHeight', _side_height: 'efCfgSideHeight' };

  function setInput(id, val) {
    var el = document.getElementById(id);
    if (!el) return false;
    el.value = val;
    ['input', 'change', 'blur'].forEach(function (t) {
      try { el.dispatchEvent(new Event(t, { bubbles: true })); } catch (e) {}
    });
    return true;
  }

  function applyDesign(sel, source) {
    var pending = [];
    for (var k in sel) {
      if (k === '__notes') {
        var notes = document.getElementById('efCfgNotes');
        if (notes) notes.value = sel[k];
        continue;
      }
      if (DIM_INPUTS[k]) { setInput(DIM_INPUTS[k], sel[k]); continue; }
      if (k.charAt(0) === '_') continue;
      pending.push(k);
    }
    var applied = 0;
    function attempt() {
      for (var i = pending.length - 1; i >= 0; i--) {
        var field = pending[i];
        var hit = null;
        var cards = document.querySelectorAll('.ef-cfg-card[data-field="' + field + '"]');
        for (var j = 0; j < cards.length; j++) {
          if (cards[j].dataset.value === sel[field]) { hit = cards[j]; break; }
        }
        /* Finish (i pokrewne) to swatche .ef-cfg-swatch z data-label, bez data-field —
           dopasowanie po samej etykiecie (nazwy finiszy nie kolidują między polami). */
        if (!hit) {
          var sw = document.querySelectorAll('.ef-cfg-swatch');
          for (var q = 0; q < sw.length; q++) {
            if (sw[q].dataset.label === sel[field]) { hit = sw[q]; break; }
          }
        }
        if (hit) {
          try { hit.click(); applied++; } catch (e) {}
          pending.splice(i, 1);
        }
      }
      return pending.length === 0;
    }
    /* Runda 1: karty już wyrenderowane (krok 1 + wszystko, co silnik zbudował z góry). */
    var tries = 0;
    (function pass() {
      tries++;
      if (!attempt() && tries < 20) { setTimeout(pass, 400); return; }
      dl('ef_cfg_restore', { source: source, applied: applied, pending: pending.length });
      toast(applied > 0 || pending.length === 0 ? 'Your design is back ✓' : 'Could not restore this design');
      /* Runda 2: silnik renderuje karty niektórych kroków dopiero przy nawigacji
         (np. finish/mesh). Obserwator DOM dociska zaległe wybory w chwili, gdy
         karty się pojawią — klient klika Next i zastaje wszystko wybrane. */
      if (pending.length && 'MutationObserver' in window) {
        var debounce = null;
        var mo = new MutationObserver(function () {
          clearTimeout(debounce);
          debounce = setTimeout(function () {
            if (attempt()) { mo.disconnect(); dl('ef_cfg_restore_late', { applied: applied }); }
          }, 250);
        });
        mo.observe(document.body, { childList: true, subtree: true });
        setTimeout(function () { mo.disconnect(); }, 90000);
      }
    })();
  }

  /* ── localStorage autosave ────────────────────────────────────── */
  var lastSaved = '';
  function autosave() {
    var snap = snapshot();
    if (!snap || !isMeaningful(snap.s)) return;
    var json = JSON.stringify(snap.s);
    if (json === lastSaved) return;
    lastSaved = json;
    try { localStorage.setItem(LS_PREFIX + snap.h, JSON.stringify(snap)); } catch (e) {}
  }

  function loadSaved() {
    try {
      var raw = localStorage.getItem(LS_PREFIX + handle());
      if (!raw) return null;
      var snap = JSON.parse(raw);
      if (!snap || !isMeaningful(snap.s)) return null;
      if (Date.now() - (snap.t || 0) > MAX_AGE_DAYS * 864e5) return null;
      return snap;
    } catch (e) { return null; }
  }

  /* ── UI: toast ────────────────────────────────────────────────── */
  var toastEl = null, toastTimer = null;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'ef-sv-toast';
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2600);
  }

  /* ── UI: baner "Welcome back" ─────────────────────────────────── */
  function showResumeBanner(snap) {
    var firstStep = document.querySelector('.ef-cfg-step');
    if (!firstStep || document.getElementById('efSvBanner')) return;
    var days = Math.floor((Date.now() - snap.t) / 864e5);
    var when = days === 0 ? 'earlier today' : (days === 1 ? 'yesterday' : days + ' days ago');
    var el = document.createElement('div');
    el.className = 'ef-sv-banner';
    el.id = 'efSvBanner';
    el.innerHTML =
      '<div class="ef-sv-banner__txt"><strong>Welcome back.</strong> Your design from ' + when + ' is saved.</div>' +
      '<div class="ef-sv-banner__btns">' +
      '<button type="button" class="ef-sv-banner__resume" id="efSvResume">Resume my design</button>' +
      '<button type="button" class="ef-sv-banner__fresh" id="efSvFresh">Start fresh</button></div>';
    firstStep.parentNode.insertBefore(el, firstStep);
    document.getElementById('efSvResume').addEventListener('click', function () {
      el.remove();
      applyDesign(snap.s, 'banner');
    });
    document.getElementById('efSvFresh').addEventListener('click', function () {
      try { localStorage.removeItem(LS_PREFIX + handle()); } catch (e) {}
      lastSaved = '';
      el.remove();
    });
  }

  /* ── UI: modal Save & share ───────────────────────────────────── */
  function klaviyoObj() { return window.klaviyo || window._learnq || null; }

  function openModal() {
    var link = buildLink();
    if (!link) { toast('Pick a few options first — then save'); return; }
    var modal = document.getElementById('efSvModal');
    modal.hidden = false;
    document.getElementById('efSvLink').value = link;
    var shareBtn = document.getElementById('efSvShare');
    shareBtn.style.display = navigator.share ? '' : 'none';
    var mailRow = document.getElementById('efSvMailRow');
    mailRow.style.display = klaviyoObj() ? '' : 'none';
    autosave();
  }

  function wireModal() {
    var modal = document.getElementById('efSvModal');
    if (!modal) return;
    document.getElementById('efSvClose').addEventListener('click', function () { modal.hidden = true; });
    modal.addEventListener('click', function (e) { if (e.target === modal) modal.hidden = true; });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') modal.hidden = true; });

    document.getElementById('efSvCopy').addEventListener('click', function () {
      var inp = document.getElementById('efSvLink');
      var done = function () { toast('Link copied ✓'); dl('ef_cfg_save', { method: 'copy' }); };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(inp.value).then(done, function () { inp.select(); document.execCommand('copy'); done(); });
      } else { inp.select(); document.execCommand('copy'); done(); }
    });

    document.getElementById('efSvShare').addEventListener('click', function () {
      var st = state();
      navigator.share({
        title: 'My ' + ((st && st.prodTitle) || 'fireplace door') + ' design — ExceptionalFire',
        url: document.getElementById('efSvLink').value
      }).then(function () { dl('ef_cfg_save', { method: 'share' }); }).catch(function () {});
    });

    document.getElementById('efSvSend').addEventListener('click', function () {
      var email = (document.getElementById('efSvEmail').value || '').trim();
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { toast('Enter a valid e-mail'); return; }
      var kl = klaviyoObj();
      if (!kl) { toast('E-mail unavailable — copy the link instead'); return; }
      var st = state();
      var props = {
        'Design URL': document.getElementById('efSvLink').value,
        'Product': (st && st.prodTitle) || handle(),
        'Total': st ? Math.round(st.calcTotal()) / 100 : null
      };
      try {
        if (typeof kl.identify === 'function') {
          /* Klaviyo onsite object (nowe API) */
          kl.identify({ email: email });
          kl.track('EF Saved Design', props);
        } else {
          /* _learnq (starsze API) */
          kl.push(['identify', { $email: email }]);
          kl.push(['track', 'EF Saved Design', props]);
        }
        dl('ef_cfg_save', { method: 'email' });
        toast('Sent — your design is on its way ✓');
        document.getElementById('efSvEmail').value = '';
      } catch (e) { toast('Could not send — copy the link instead'); }
    });
  }

  /* ── Expert CTA: tracking + nudge ─────────────────────────────── */
  function wireExpert() {
    var card = document.getElementById('efExpertCard');
    if (!card) return;
    var video = document.getElementById('efExpertVideo');
    var phone = document.getElementById('efExpertPhone');
    if (video) video.addEventListener('click', function () { dl('ef_cfg_expert_cta', { action: 'video' }); });
    if (phone) phone.addEventListener('click', function () { dl('ef_cfg_expert_cta', { action: 'phone' }); });

    var nudged = false;
    function nudge(why) {
      if (nudged) return;
      nudged = true;
      card.classList.add('ef-exph-nudge');
      dl('ef_cfg_expert_nudge', { reason: why });
    }
    /* 2 nieudane parse'y wymiarów → nudge */
    var badBlur = 0;
    ['efCfgWidth', 'efCfgHeight'].forEach(function (id) {
      var el = document.getElementById(id);
      if (!el) return;
      el.addEventListener('blur', function () {
        var v = el.value.trim();
        if (!v) return;
        var ok = /^\d+(\.\d+)?$/.test(v) || /^\d+\s*[-\s]\s*\d+\s*\/\s*\d+$/.test(v) || /^\d+\s*\/\s*\d+$/.test(v);
        if (!ok && ++badBlur >= 2) nudge('invalid_dims');
      });
    });
    /* 25 s w widoku karty → nudge */
    if ('IntersectionObserver' in window) {
      var t = null;
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) { if (!t) t = setTimeout(function () { nudge('dwell'); }, 25000); }
          else if (t) { clearTimeout(t); t = null; }
        });
      }, { threshold: 0.4 });
      io.observe(card);
    }
  }

  /* ── init ─────────────────────────────────────────────────────── */
  function init() {
    if (!state()) { setTimeout(init, 400); return; }
    wireModal();
    wireExpert();
    var openBtn = document.getElementById('efSvOpen');
    if (openBtn) openBtn.addEventListener('click', openModal);

    var params = new URLSearchParams(location.search);
    var efd = params.get('efd');
    if (efd) {
      var data = b64d(efd);
      if (data && data.s && data.h === handle()) {
        /* dane + karty potrzebują chwili po _efCfgState */
        setTimeout(function () { applyDesign(data.s, 'url'); }, 900);
      }
    } else {
      var saved = loadSaved();
      if (saved) showResumeBanner(saved);
    }
    setInterval(autosave, 3000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
